module.exports = __webpack_public_path__ + "static/img/desktop1.cf07ae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/desktop1.jpg
// module id = r6YS
// module chunks = 12